import { View, hexColor } from "@lightningtv/solid";

// A rounded box with a border. The border is a second layer behind the box,
// because color props update reliably when they change but style borders do not.
const Box = (props: {
  x?: number; y?: number; width: number; height: number; radius: number;
  fill: string; border: string; borderWidth?: number; children?: any;
}) => {
  const bw = () => props.borderWidth ?? 2;
  return (
    <View x={props.x ?? 0} y={props.y ?? 0} width={props.width} height={props.height}
      borderRadius={props.radius} color={hexColor(props.border)}>
      <View x={bw()} y={bw()} width={props.width - bw() * 2} height={props.height - bw() * 2}
        borderRadius={props.radius - bw()} color={hexColor(props.fill)} />
      {props.children}
    </View>
  );
};

export default Box;
